import React from 'react'
import { useField } from 'formik'
import { Switch } from '@headlessui/react'
import classnames from 'classnames'

interface FormikToggleProps {
  name: string
  label: string
  subLabel?: string
  disabled?: boolean
}

const FormikToggle: React.FC<FormikToggleProps> = ({ name, label, subLabel, disabled }) => {
  const [field, , helpers] = useField(name)

  const toggle = (
    <Switch
      checked={field.value}
      onChange={(newCheckedValue: boolean) => helpers.setValue(newCheckedValue)}
      className={classnames(
        field.value === true ? 'bg-emerald-500 dark:bg-emerald-600 border-transparent' : 'bg-slate-200 dark:bg-slate-700 border-slate-300 dark:border-slate-600',
        'relative inline-flex shrink-0 h-6 w-11 border-2 rounded-full transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 dark:focus:ring-offset-slate-900'
      )}
      disabled={disabled}
    >
      <span
        aria-hidden="true"
        className={classnames(
          field.value === true ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none inline-block h-5 w-5 rounded-full bg-white dark:bg-slate-100 shadow transform ring-0 transition ease-in-out duration-200'
        )}
      />
    </Switch>
  )

  if (subLabel) {
    return (
      <Switch.Group as="div" className="flex flex-col gap-1">
        <div className="flex items-center">
          {toggle}
          <Switch.Label as="span" className="ml-3 pointer-events-none">
            <span className="text-sm font-medium text-slate-700 dark:text-slate-300">{label}</span>
          </Switch.Label>
        </div>
        <span className="text-xs text-slate-500 dark:text-slate-400">{subLabel}</span>
      </Switch.Group>
    )
  }

  return (
    <Switch.Group as="div" className="flex">
      <Switch.Label as="span" className="mr-3 pointer-events-none">
        <span className="text-sm font-medium text-slate-700 dark:text-slate-300">{label}</span>
      </Switch.Label>
      {toggle}
    </Switch.Group>
  )
}

export default FormikToggle
